export default __webpack_public_path__ + "static/media/foto1.496ba94a.jpg";